import { render } from "./ApprovePass.vue?vue&type=template&id=7b5d1d19"
import script from "./ApprovePass.vue?vue&type=script&lang=js"
export * from "./ApprovePass.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__